export default {

    initialfieldsstate: {
        first_name: {
            value: ""
        },
        last_name: {
            value: ""
        },
        email: {
            value: ""
        },
        checkBoxMember: {
            value: false
        },
        memberno: {
            value: ""
        },
        address1: {
            value: ""
        },
        address2: {
            value: ""
        },
        phone_number: {
            value: ""
        },
        city: {
            value: ""
        },
        state: {
            value: ""
        },
        zip: {
            value: ""
        },
        country: {
            value: ""
        },
        MonthSelect: {
            value: ""
        },
        YearSelect: {
            value: ""
        },
        billingAddressSame: {
            value: true
        },
        shipping_address1: {
            value: ""
        },
        shipping_address2: {
            value: ""
        },
        shipping_phone_number: {
            value: ""
        },
        shipping_city: {
            value: ""
        },
        shipping_state: {
            value: ""
        },
        shipping_zip: {
            value: ""
        },
        shipping_country: {
            value: ""
        }
    }
}